import { Badge } from "@/components/ui/badge";
import type { PlacementState } from "@/lib/api";

const STYLES: Record<PlacementState, string> = {
  programado: "bg-amber-100 text-amber-800 border-amber-200",
  finalizado: "bg-blue-100 text-blue-800 border-blue-200",
  realizado: "bg-emerald-100 text-emerald-800 border-emerald-200",
  cancelado: "bg-rose-100 text-rose-800 border-rose-200",
};

const LABELS: Record<PlacementState, string> = {
  programado: "Programado",
  finalizado: "Finalizado",
  realizado: "Realizado",
  cancelado: "Cancelado",
};

export function AdStateBadge({ state }: { state: PlacementState | string }) {
  const s = state as PlacementState;
  return <Badge className={STYLES[s] ?? ""} variant="outline">{LABELS[s] ?? state}</Badge>;
}
